"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const xeroIntegration_1 = __importDefault(require("@powerednow/shared/modules/xero/xeroIntegration"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const syncable_1 = __importDefault(require("@powerednow/complexData/mixin/syncable"));
const decorator_1 = require("@powerednow/complexData/decorator");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const constants = require('@powerednow/shared/constants').default;
const _ = require('lodash');
const moment = require('moment');
let CompanyIntegration = 
// eslint-disable-next-line no-redeclare
class CompanyIntegration extends complexData_1.default {
    isDisconnected() {
        return _.isEmpty(this.data.token);
    }
    getConnectionStatus(ACCESS_TOKEN_CLASS) {
        if (this.isDisconnected()) {
            return constants.INTEGRATION.CONNECTION_STATUS.NOT_CONNECTED;
        }
        const accessToken = new ACCESS_TOKEN_CLASS(this.data.token);
        if (accessToken.isExpired()) {
            return constants.INTEGRATION.CONNECTION_STATUS.EXPIRED;
        }
        return constants.INTEGRATION.CONNECTION_STATUS.CONNECTED;
    }
    disconnect() {
        this.data.token = {};
        this.data.integration_data = null;
    }
    startInterfacing() {
        this.data.is_started = true;
    }
    isRunning() {
        return !_.isEmpty(this.data.token) && this.data.is_enabled && this.data.is_started && moment(this.data.interfacing_start_date).isSameOrBefore(new Date(), 'day');
    }
    isAutoSynced() {
        return this.isRunning() && this.data.settings.automaticInterfacing;
    }
    validateAccountCodeSettings() {
        return xeroIntegration_1.default.validateAccountCodeSettings(this);
    }
    validateBankAccountCodeSettings() {
        return xeroIntegration_1.default.validateBankAccountCodeSettings(this);
    }
};
CompanyIntegration.Entity = entity_1.default;
CompanyIntegration.modelProperties = modelProperties_1.default;
CompanyIntegration = __decorate([
    (0, decorator_1.complexDataMix)(syncable_1.default)
    // eslint-disable-next-line no-redeclare
], CompanyIntegration);
exports.default = CompanyIntegration;
//# sourceMappingURL=../../../../src/models/companyIntegration/index.js.map